import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GeneratePdfService {
  private readonly activeBlobUrls = new Map<string, string>();

  displayPdf(
    base64Pdf: string,
    type: 'aiReport' | 'consultationReport' | 'previewFinalReportContent'
  ) {
    const normalizedBase64 = this.normalizeBase64(base64Pdf);
    const byteCharacters = atob(normalizedBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);

    const iframe = document.createElement('iframe');
    iframe.src = blobUrl;
    iframe.width = '100%';
    iframe.height = '600px';
    iframe.style.border = 'none';

    let content: HTMLElement | null = null;
    content = document.getElementById(type);

    if (content) {
      const previousBlobUrl = this.activeBlobUrls.get(type);
      if (previousBlobUrl) {
        URL.revokeObjectURL(previousBlobUrl);
      }

      content.innerHTML = '';
      content.appendChild(iframe);
      this.activeBlobUrls.set(type, blobUrl);
    }
  }

  private normalizeBase64(base64Pdf: string): string {
    if (base64Pdf.startsWith('data:application/pdf;base64,')) {
      return base64Pdf.split(',')[1];
    }

    return base64Pdf;
  }
}
